import React from "react";
import StreamMedia from "../App/Models/StreamMedia";
import classNames from 'classnames';
interface Props{
    media: StreamMedia;
    extMedia: StreamMedia;
    type: string;
}
class StreamContentDisplay extends React.Component{
    resolveMedia = () => {
        if(this.props.media){
            // if(this.props.media._path){
            //     return window.appSettings.aemStreamContentUrl + this.props.media._path
            // }
            return this.props.media
        }
        if(this.props.extMedia){
            return this.props.extMedia
        }
        const result: StreamMedia = {
            __typename: '',
            _path: ''
        }
        return result;
    }
    
    renderImage = () => {
        const media = this.resolveMedia();
        return(
            <div className={classNames('c-dashboard__tile-stream-news-image', _.isEmpty(this.resolveMedia._path) ? 'no-thumbnail' : '')}>
                <img src={this.resolveMedia._path} />
            </div>
        )
    }

    render(): React.ReactNode {
        const media: StreamMedia = this.resolveMedia()
        //console.log('media list')
        //console.log(this.props)
        //console.log(media)
        switch(this.props.type){
            case 'youtube':
            case 'vimeo':
            case 'spotify':
                return(
                    <div
                    className={classNames('c-dashboard__article-content-video', _.isEmpty(media) ? 'no-thumbnail' : '')}
                    dangerouslySetInnerHTML={{ __html: media }}
                    >                        
                    </div>
                )
            case 'AEM asset':
                if(media.__typename == 'ImageRef'){
                    return(
                        <img
                            className={classNames('c-dashboard__article-content-image', _.isEmpty(media._path) ? 'no-thumbnail' : '')}
                            src={window.appSettings.aemStreamContentUrl + media._path}
                        ></img>
                    )
                }
                else if(media.__typename == 'MultimediaRef'){
                    return(
                            <video
                             className={classNames('c-dashboard__article-content-video', _.isEmpty(media._path) ? 'no-thumbnail' : '')}
                             src={window.appSettings.aemStreamContentUrl + media._path}
                            >
                            </video>
                        )
                }
            default:
                return(null)
        }


        
    }

}

export default StreamContentDisplay;